import Service from "./Service";
const baseurl = '/api/valoraciones';

export default {
    index(params={}) {
        return Service.get(`${baseurl}`,{
            params: params
        });
    }
}